var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6" }, [
                _c("h5", [_vm._v("Врач")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selected_doctor,
                        expression: "selected_doctor",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selected_doctor = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "0", disabled: "" } }, [
                      _vm._v("Выберите врача"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.receipt_docs, function (doc) {
                      return _c("option", { domProps: { value: doc.id } }, [
                        _vm._v(
                          _vm._s(doc.name) +
                            "\n                  (" +
                            _vm._s(doc.specialty) +
                            ")\n                "
                        ),
                      ])
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Дата")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|min:2|max:255",
                          expression: "'required|min:2|max:255'",
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.receipt_date,
                          expression: "receipt_date",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        name: "receipt_date_name",
                        "data-vv-as": "Дата",
                      },
                      domProps: { value: _vm.receipt_date },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.receipt_date = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.has("receipt_date_name")
                      ? _c("small", { staticClass: "form-text text-danger" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.errors.first("receipt_date_name")) +
                              "\n                  "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Номер первого рецепта"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|numeric|integer",
                          expression: "'required|numeric|integer'",
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.receipt_number,
                          expression: "receipt_number",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        name: "receipt_number_name",
                        "data-vv-as": "номер рецепта",
                      },
                      domProps: { value: _vm.receipt_number },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.receipt_number = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.has("receipt_number_name")
                      ? _c("small", { staticClass: "form-text text-danger" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.errors.first("receipt_number_name")) +
                              "\n                  "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("h5", [_vm._v("Шаблон")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selected_template,
                        expression: "selected_template",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selected_template = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.receipt_templates, function (doc) {
                    return _c("option", { domProps: { value: doc.id } }, [
                      _vm._v(_vm._s(doc.title) + "\n                "),
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Номер накладной для импорта препаратов"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.importDrugsInvoiceNum,
                        expression: "importDrugsInvoiceNum",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "Номер накладной" },
                    domProps: { value: _vm.importDrugsInvoiceNum },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.importDrugsInvoiceNum = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-1 text-right" },
                    [
                      _c("LoadingButton", {
                        attrs: {
                          title: "Импортировать препараты",
                          type: "button",
                          loading: _vm.btnImportDrugsLoading,
                          color: _vm.$constants.PRIMARY_COLOR,
                          onClick: () => _vm.importDrugsFromInvoice(),
                          className: "btn btn-outline-info btn-xs",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row action_btns" }, [
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _vm.generatedTemplates.length
                    ? [
                        _c("p", [_vm._v("Сгенерированы рецепты:")]),
                        _vm._v(" "),
                        _vm._l(_vm.generatedTemplates, function (g) {
                          return _c(
                            "div",
                            { staticClass: "alert alert-info p-1 mb-1" },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.receipt_docs.find(
                                      (d) => d.id === g.doctor
                                    )?.name
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "номера рецептов " +
                                    _vm._s(g.number) +
                                    " - " +
                                    _vm._s(g.lastNumber) +
                                    " (препаратов:\n                    "
                                ),
                                _c("strong", [_vm._v(_vm._s(g.drugsQty))]),
                                _vm._v(")"),
                              ]),
                            ]
                          )
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6 text-rigth" },
                [
                  _c(
                    "vue-ladda",
                    {
                      attrs: {
                        "button-class": "btn btn-success",
                        "data-style": "zoom-in",
                        loading: _vm.submit_form_loading_test,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.createReceipt(false)
                        },
                      },
                    },
                    [_vm._v("Тестовая печать\n              ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "vue-ladda",
                    {
                      attrs: {
                        "button-class": "btn btn-info",
                        "data-style": "zoom-in",
                        loading: _vm.submit_form_loading,
                      },
                      on: { click: _vm.createReceipt },
                    },
                    [_vm._v("Создать рецепт (статистика)\n              ")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "flex justify-content-between mb-1" }, [
              _c("h5", [_vm._v("Препарат")]),
              _vm._v(" "),
              _c("div", { staticClass: "text-rigth" }, [
                _c("p", { staticClass: "mb-0" }, [
                  _vm._v("препаратов: "),
                  _c("strong", [_vm._v(_vm._s(_vm.totalDrugsData.drugs))]),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "mb-0" }, [
                  _vm._v("рецептов: "),
                  _c("strong", [_vm._v(_vm._s(_vm.totalDrugsData.receipts))]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return (() => _vm.addDrug()).apply(null, arguments)
                  },
                },
              },
              [
                _c("div", { staticClass: "flex" }, [
                  _c(
                    "div",
                    { staticClass: "flex-grow-1" },
                    [
                      _c("DrugSearchNew", {
                        ref: "newDrug",
                        attrs: {
                          onSelect: (d) => _vm.newDrugAdd(d),
                          searchOptions: { details: true },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex" }, [
                    _c("input", {
                      ref: "newQty",
                      staticClass: "form-control",
                      attrs: {
                        required: "",
                        placeholder: "Кол.",
                        type: "number",
                      },
                    }),
                    _vm._v(" "),
                    _vm._m(1),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-12" }, [
        _vm.selected_preps
          ? _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "table",
                    { staticClass: "table table-hover" },
                    [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [_vm._v("Препарат")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Безрецептурный (ОТС)")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Название на латыне")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Signa")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Упак./дней")]),
                          _vm._v(" "),
                          _c("th", { attrs: { colspan: "2" } }, [
                            _c(
                              "div",
                              { staticClass: "flex justify-content-between" },
                              [
                                _c("div", { staticClass: "align-self-end" }, [
                                  _vm._v("Кол. упаковок"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-default",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        _vm.selected_preps = []
                                      },
                                    },
                                  },
                                  [_vm._v("Удалить все")]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("th"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.selected_preps, function (drug, index) {
                        return _c("tbody", [
                          _c(
                            "tr",
                            {
                              ref: "`tr_prep_${drug.id}`",
                              refInFor: true,
                              attrs: { id: `tr_prep_${drug.id}` },
                            },
                            [
                              _c("td", [
                                _c("i", {
                                  staticClass:
                                    "icon-fa icon-fa-edit openEditDrugIcon",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openDrugEdit(drug.id)
                                    },
                                  },
                                }),
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(drug.title) +
                                    "\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.printPrepReceipt(
                                      drug.recipe.no_use.int_value
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    (drug.recipe.lt_title &&
                                      drug.recipe.lt_title.text_value) ||
                                      "не указано"
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    (drug.recipe.signa &&
                                      drug.recipe.signa.text_value) ||
                                      "не указано"
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  drug.editFormula
                                    ? [
                                        _c("div", [
                                          _c(
                                            "div",
                                            { staticClass: "input-group" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      drug.recipe.pack
                                                        .int_value,
                                                    expression:
                                                      "drug.recipe.pack.int_value",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: { type: "number" },
                                                domProps: {
                                                  value:
                                                    drug.recipe.pack.int_value,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      drug.recipe.pack,
                                                      "int_value",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _vm._m(2, true),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      drug.recipe.days
                                                        .int_value,
                                                    expression:
                                                      "drug.recipe.days.int_value",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: { type: "number" },
                                                domProps: {
                                                  value:
                                                    drug.recipe.days.int_value,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      drug.recipe.days,
                                                      "int_value",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    : [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex align-items-center",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  drug.recipe.pack.int_value
                                                ) +
                                                  " / " +
                                                  _vm._s(
                                                    drug.recipe.days.int_value
                                                  )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-default ml-2",
                                                on: {
                                                  click: function ($event) {
                                                    drug.editFormula = true
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "icon-fa icon-fa-edit",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("td", [
                                !drug.recipe.no_use.int_value
                                  ? _c("div", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value:
                                              "required|integer|integer|max_value:9000|max:4",
                                            expression:
                                              "'required|integer|integer|max_value:9000|max:4'",
                                          },
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.requested_qnty[drug.id],
                                            expression:
                                              "requested_qnty[drug.id]",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          name: `req_qnty_${drug.id}`,
                                          placeholder: "Кол. упаковок",
                                          "data-vv-as": "Кол. упаковок",
                                        },
                                        domProps: {
                                          value: _vm.requested_qnty[drug.id],
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.requested_qnty,
                                              drug.id,
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.errors.has(`req_qnty_${drug.id}`)
                                        ? _c(
                                            "small",
                                            {
                                              staticClass:
                                                "form-text text-danger",
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      `req_qnty_${drug.id}`
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-sm btn-danger",
                                    on: {
                                      click: function ($event) {
                                        return _vm.removePrep(drug.id)
                                      },
                                    },
                                  },
                                  [_vm._v("x")]
                                ),
                              ]),
                            ]
                          ),
                        ])
                      }),
                    ],
                    2
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Врач и шаблон")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      { staticClass: "btn btn-outline-success", attrs: { type: "submit" } },
      [_c("i", { staticClass: "icon-fa icon-fa-plus" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "input-group-prepend input-group-append" },
      [_c("span", { staticClass: "input-group-text" }, [_vm._v("/")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }